export const ASYNC_OPERATION_SUCCESS = 'alert/SUCCESS';
export const ASYNC_OPERATION_ERROR = 'alert/ERROR';
export const asyncOperationCompletedWithSuccess = (payload: any) => ({ payload, type: ASYNC_OPERATION_SUCCESS });
export const asyncOperationCompletedWithError = (payload: any) => ({ payload, type: ASYNC_OPERATION_ERROR });

export const MODAL_CLOSE = 'alert/MODAL_CLOSE';
export const modalClose = () => ({ type: MODAL_CLOSE });
